module.exports = __webpack_public_path__ + "img/icon_join.2007c875.svg";